import React from 'react';
import { BsFormControl, BsFormSelect, BsModalForm } from '../../collection/bootstrap/BootstrapComponents';
import { useLoad } from '../../collection/Hooks';
import Loading from '../../collection/icons/Loading';
import { apiForm, apiGet } from '../../utils/api';

export default function HorasExtraResponsableModal(props) {
    const updateData = async () => await apiGet("horasextras/get/" + props.idHorasExtra);

    const checkData = formData => {
        let errors = {};
        // Cliente
        const cliente = formData.get("cliente");
        if (!cliente) {
            errors["cliente"] = "Campo obligatorio";
        }
        return errors;
    }

    const saveData = async data => {
        const result = await apiForm("horasextras/comment", data);
        if (result) {
            props.onHide();
        }
    }

    return (
        <BsModalForm
            onUpdate={updateData}
            onCheck={checkData}
            onSave={saveData}
            modalTitle="Editar horas extra"
            show={props.show}
            onHide={props.onHide}
            saveOnEnter>
            <HorasExtraResponsableForm />
        </BsModalForm>
    );
}

function HorasExtraResponsableForm(props) {
    const data = props.data;
    const errors = props.errors;

    const [listClientes, reload] = useLoad(async () => await apiGet("clientes/list"));

    return listClientes ? <>
        <BsFormSelect
            /* Cliente */
            label="Cliente" name="cliente"
            value={data.cliente} error={errors.cliente}
            options={listClientes}
            className="mt-3" />
        <BsFormControl
            /* Comentario */
            label="Comentario" name="comentarioResponsable"
            value={data.comentarioResponsable} error={errors.comentarioResponsable}
            className="mt-3" maxLength="250" as="textarea" />
    </> : <Loading />;
}
